import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-custom-search-field',
  templateUrl: './custom-search-field.component.html',
  styleUrls: ['./custom-search-field.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => CustomSearchFieldComponent),
    },
  ],
})
export class CustomSearchFieldComponent implements ControlValueAccessor {
  @Input() placeholder = 'Keresés';
  @Input() ariaLabel = 'Keresés';
  @Input() maxWidth = '400px';

  value = '';
  isSearchFocused = false;
  disabled = false;

  onChange: (value: string) => void = () => {};
  onTouched = () => {};

  writeValue(value: string): void {
    this.value = value || '';
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onInput(event: Event): void {
    const target = event.target as HTMLInputElement;
    this.value = target.value;
    this.onChange(this.value);
  }

  onFocus(): void {
    this.isSearchFocused = true;
  }

  onBlur(): void {
    this.isSearchFocused = false;
    this.onTouched();
  }

  clearSearch(): void {
    this.value = '';
    this.onChange(this.value);
  }
}
